import type { ComponentProps } from "react"
import { SelectGroup as SelectGroupBase } from "@/v2-ui/select/base/SelectBase"

export type SelectGroupProps = ComponentProps<typeof SelectGroupBase>

function SelectGroup(props: SelectGroupProps) {
  const { ...selectGroupBaseProps } = props
  return <SelectGroupBase {...selectGroupBaseProps} />
}

export default SelectGroup
